// extracted by mini-css-extract-plugin
export default {"LocalUploader":"LocalUploader_LocalUploader__2XV8S"};